// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"653":"c195584b","707":"4be2410b","953":"99e33141"}[chunkId] + ".chunk.js";
};